var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "#F0FDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 19.75H20.5C19.9033 19.75 19.331 19.9871 18.909 20.409C18.4871 20.831 18.25 21.4033 18.25 22V32.5C18.25 33.0967 18.4871 33.669 18.909 34.091C19.331 34.5129 19.9033 34.75 20.5 34.75H35.5C36.0967 34.75 36.669 34.5129 37.091 34.091C37.5129 33.669 37.75 33.0967 37.75 32.5V22C37.75 21.4033 37.5129 20.831 37.091 20.409C36.669 19.9871 36.0967 19.75 35.5 19.75ZM36.25 32.5C36.25 32.6989 36.171 32.8897 36.0303 33.0303C35.8897 33.171 35.6989 33.25 35.5 33.25H20.5C20.3011 33.25 20.1103 33.171 19.9697 33.0303C19.829 32.8897 19.75 32.6989 19.75 32.5V22C19.75 21.8011 19.829 21.6103 19.9697 21.4697C20.1103 21.329 20.3011 21.25 20.5 21.25H35.5C35.6989 21.25 35.8897 21.329 36.0303 21.4697C36.171 21.6103 36.25 21.8011 36.25 22V32.5ZM31.75 37C31.75 37.1989 31.671 37.3897 31.5303 37.5303C31.3897 37.671 31.1989 37.75 31 37.75H25C24.8011 37.75 24.6103 37.671 24.4697 37.5303C24.329 37.3897 24.25 37.1989 24.25 37C24.25 36.8011 24.329 36.6103 24.4697 36.4697C24.6103 36.329 24.8011 36.25 25 36.25H31C31.1989 36.25 31.3897 36.329 31.5303 36.4697C31.671 36.6103 31.75 36.8011 31.75 37Z",
    fill: "#166534"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIcon);
export default __webpack_public_path__ + "static/media/manualIcon.f16a477d9b925b150f3a1fc28283754b.svg";
export { ForwardRef as ReactComponent };